import Vue from 'vue';
import axios from 'axios'

let url = null
let host = window.location.hostname
if(host == 'localhost'){
  url = 'http://localhost/vue/cetaba-aulas/php/'
}else{
  url = './php/'
}

Vue.use({
  install (Vue) {
    Vue.prototype.$axiosPost = axios.create({
      baseURL: url,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Accept': 'application/json',
      },
    }),
    Vue.prototype.$axiosGet = axios.create({
      baseURL: url,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    })
  }
})


export default{};